/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, time: NonNullable<unknown> }} Features_Hero_Chip_BookedInputs */

const en_features_hero_chip_booked = /** @type {(inputs: Features_Hero_Chip_BookedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} booked ${i?.time}`)
};

const pl_features_hero_chip_booked = /** @type {(inputs: Features_Hero_Chip_BookedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} zarezerwowała ${i?.time}`)
};

/**
* | output |
* | --- |
* | "{name} booked {time}" |
*
* @param {Features_Hero_Chip_BookedInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_hero_chip_booked = /** @type {((inputs: Features_Hero_Chip_BookedInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Hero_Chip_BookedInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_hero_chip_booked(inputs)
	return en_features_hero_chip_booked(inputs)
});